import React from 'react';
import { Nav } from 'react-bootstrap';

export default function DiscreteTab({
  title,
  path,
}: {
  title: string;
  path: string;
}) {
  return (
    <Nav title={title} data-path={path} />
  );
}
